import { useContext, useCallback } from 'react';
import { setRefs } from '../../utils/refHelpers';
import { DropdownStateContext } from '../DropdownStateManager';
import { PopperDropdownContext } from '../PopperDropdownLayout/PopperDropdownContext';
/**
 * Returns the necessary props for a button to interact with our popper/dropdown implementation. Spread these out on your button and you should be good!
 *
 * Required contexts: {@link PopperDropdownContext}, {@link DropdownStateContext}
 */
export function useDropdownToggleProps() {
    var setPopperToggleRef = useContext(PopperDropdownContext).setToggleRef;
    var _a = useContext(DropdownStateContext), setDropdownToggleRef = _a.setToggleRef, isOpen = _a.isOpen;
    var innerRef = useCallback(function (node) { return setRefs([setPopperToggleRef, setDropdownToggleRef], node); }, [setPopperToggleRef, setDropdownToggleRef]);
    return {
        innerRef: innerRef,
        'aria-expanded': isOpen,
    };
}
//# sourceMappingURL=useDropdownToggleProps.js.map